<!-- <div class="my-products">
	<ng-container *ngIf="myProducts.length > 0">
		<div class="my-products__card" *ngFor="let row of myProducts | paginate: paginator">
			<div class="my-products__card--image">
				<img src="{{ row.product_image }}" alt="">
			</div>
			<div class="my-products__card--content">
				<div class="top-items">
					<span class="name">{{ row.category | titlecase }}</span>
					<span class="id-num">ID : {{ row.product_number }}</span>
					<div class="new-create-switch">
						<div class="switch-wrapper">
							<div class="switch">
								<input type="checkbox" id="auto-renew" name="auto-renew" [checked]="row.active" (click)="showHideProduct(row)">
								<span class="slider round"></span>
							</div>
						</div>
					</div>
				</div>
				<div class="description">
					{{ row.name | titlecase }}
				</div>
				<div class="discount" *ngIf="row.discount_percent">
					<span class="cut-price">{{ row.price }} </span>
					<span class="sar-cur">{{ basicInfo.currency_symbol }}</span>
					<span class="mines-price">-{{ row.discount_percent }}%</span>
				</div>
				<div class="price-section">
					<div class="price-section--price" i18n="@@products.price">
						Price:
					</div>
					<div class="price-section--amount">
						{{ row.net_price }}
						<span class="sar-cur">{{ basicInfo.currency_symbol }}</span>
					</div>
				</div>

	      <div class="dropdown more-items" ngbDropdown container="body" placement="bottom-right">
	        <a ngbDropdownToggle href="javascript:void(0)" >
						<svg width="18" height="5" viewBox="0 0 18 5">
							<path fill-rule="evenodd" d="M2.143 0c1.183 0 2.143.96 2.143 2.143 0 1.183-.96 2.143-2.143 2.143C.959 4.286 0 3.326 0 2.143 0 .959.96 0 2.143 0zM9 0c1.183 0 2.143.96 2.143 2.143 0 1.183-.96 2.143-2.143 2.143-1.183 0-2.143-.96-2.143-2.143C6.857.959 7.817 0 9 0zm6.857 0C17.041 0 18 .96 18 2.143c0 1.183-.96 2.143-2.143 2.143-1.183 0-2.143-.96-2.143-2.143 0-1.184.96-2.143 2.143-2.143z"/>
						</svg>
					</a>
					<div ngbDropdownMenu class="dropdown-menu-left" aria-labelledby="dropdownBasic1">
		        <div ngbDropdownItem class="cursor-pointer" (click)="editProduct(row)" i18n="@@products.edit" >Edit</div>
		        <div ngbDropdownItem class="cursor-pointer" (click)="onDelete.emit(row)" i18n="@@products.delete" >Delete</div>
		      </div>
	      </div>
			</div>
		</div>
	</ng-container>
</div> -->

<div class="container">
	<div class="cards-wrapper" style="display: grid;">
		<div class="product_card" *ngFor="let row of myProducts | paginate: paginator; index as i" [class.disabled]="!row?.active">
			<div class="my-products__card--image">
				<img appLazyLoad="{{ row.product_image }}" loading="lazy" alt="{{ row.name | titlecase }}">
			</div>
			<div class="card_title">
				<h3>{{ row.name | titlecase }} <span *ngIf="row.name_ar" style="background: #fafafa; padding: 0px 10px 0 0; display: block; color: #9B9B9B; font-size: 12px; position: unset; transform: unset;">- {{ row.name_ar }}</span></h3>
				<div class="status_wrapper">
                    <span i18n="@@ts.active" *ngIf="row.active">Active</span>
                    <span i18n="@@ts.inactive" *ngIf="!row.active">Inactive</span>
                    <div class="switch-wrapper">
                        <div class="switch">
                            <input class="product-switch" type="checkbox" [checked]="row.active" (change)="showHideProduct(row, 'active', 'status-update')">
                            <span class="slider round"></span>
                        </div>
                    </div>
                </div>
				<div class="status_wrapper">
                    <span i18n="@@ts.active" *ngIf="row.in_stock">In Stock</span>
                    <span i18n="@@ts.inactive" *ngIf="!row.in_stock">Sold Out</span>
                    <div class="switch-wrapper">
                        <div class="switch">
                            <input class="product-switch" type="checkbox"  [checked]="row.in_stock"  (change)="showHideProduct(row, 'in_stock', 'stock-status')" >
                            <span class="slider round"></span>
                        </div>
                    </div>
                </div>
				<div class="status_wrapper">
					<span class="category_food">
						{{ row.category | titlecase }}
						<span *ngIf="row?.category_ar">
							/ {{ row.category_ar }}
						</span>
					</span>
					<p>ID<span class="underline-secondary order_id">#{{ row.product_number }}</span></p>
				</div>
				<div class="status_wrapper">
					<span>Price</span>
					<span class="order_total">
						<span class="sar" [innerHtml]="basicInfo?.currency_symbol"></span>
						{{ row.net_price }}
					</span>
				</div>
				<div class="custom-checkbox">
					<input [class.disabled]="!row?.active" class="styled-checkbox select-item orders_inputAll" id="product-styled-checkbox-{{i}}" type="checkbox" (click)="toggleSelect(row[selectKey], row)" [checked]="selected.includes(row[selectKey])">
					<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
					</svg>
					<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
						<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
				<div class="options-menu options-menu-{{i}} d-none">
                    <button [class.disabled]="!row?.active" class="edit-option order_id" (click)="editProduct(row)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M14.9999 8.33326L11.6666 4.99993M2.08325 17.9166L4.90356 17.6032C5.24813 17.5649 5.42042 17.5458 5.58146 17.4937C5.72433 17.4474 5.86029 17.3821 5.98566 17.2994C6.12696 17.2062 6.24954 17.0836 6.49469 16.8385L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L3.16136 13.5052C2.91621 13.7503 2.79363 13.8729 2.70045 14.0142C2.61778 14.1396 2.55243 14.2755 2.50618 14.4184C2.45405 14.5794 2.43491 14.7517 2.39662 15.0963L2.08325 17.9166Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <ng-container i18n="@@products.edit">Edit</ng-container>
                    </button>
                    <button [class.disabled]="!row?.active" (click)="onDelete.emit(row)" class="delete-option delete_product_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <ng-container i18n="@@products.delete">Delete</ng-container>
                    </button>
                </div>
                <div class="dots_container-rounded" [class.disabled]="!row?.active" (click)="showHideActions(i)">
                    <svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                        <path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
			</div>
		</div>
	</div>
</div>
